'use strict';

/**
 * Zero pad
 */
export const zeroPad = (num, length) => {
  const n = Math.abs(num);
  const zeros = Math.max(0, length - Math.floor(n).toString().length);
  let zeroString = Math.pow(10, zeros)
    .toString()
    .substr(1);
  if (num < 0) {
    zeroString = '-' + zeroString;
  }
  return zeroString + n;
};

export const commaNumber = (num) => {
  num = num.toString();
  const pattern = /(-?\d+)(\d{3})/;
  while (pattern.test(num)) num = num.replace(pattern, '$1,$2');
  return num;
};

/*
=================================================================================================
  EASING // t = time, b = start value, c = end value, d = duration
=================================================================================================
*/

export const easeInQuad = (t, b, c, d) => {
  return c * (t /= d) * t + b;
};

export const easeOutQuad = (t, b, c, d) => {
  return -c * (t /= d) * (t - 2) + b;
};
